// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AuZ8","clinicsSelect":"styles_clinicsSelect__1lRqj"};